// TimerContext.js
import React, { createContext, useContext} from 'react';
const TimerContext = createContext();
import { useActiveTimer } from '@/hooks/useActiveTimer';

export const TimerProvider = ({ children }) => {
  const timer = useActiveTimer(30000);
  return (
    <TimerContext.Provider value={timer}>
      {children}
    </TimerContext.Provider>
  );
};

export const useTimerContext = () => useContext(TimerContext);